import React from 'react';
import { useBaseEntity } from '../../EntityContext';
import { EntityType } from '../../../../../types.generated';
import { EntityList } from './components/EntityList';
import { useEntityRegistry } from '../../../../useEntityRegistry';
import { useTranslation } from '../../../../../i18n/useTranslation';

export const DashboardChartsTab = () => {
    const { t } = useTranslation();
    const entity = useBaseEntity() as any;
    const dashboard = entity && entity.dashboard;
    const charts = dashboard?.charts?.relationships.map((relationship) => relationship.entity);
    const entityRegistry = useEntityRegistry();
    const totalCharts = dashboard?.charts?.total || 0;
    const title = t('Contains {{totalCharts}} {{chart}}', {
        totalCharts,
        chart:
            totalCharts === 1
                ? entityRegistry.getEntityName(EntityType.Chart)
                : entityRegistry.getCollectionName(EntityType.Chart),
    });
    return <EntityList title={title} type={EntityType.Chart} entities={charts || []} />;
};
